import { defineStore } from 'pinia';
import AdminService from '@/services/admin.service';
import PublicService from '@/services/public.service';
import { useMainStore } from '@/stores/mainStore';

export const usePreInscriptionMaxiraceStore = defineStore('preInscriptionMaxirace', {
    state: () => ({
        id_module: null,
        filter_type: 'code_postal',
        filter_value: '',
        loading: false,
        selection: null,
        courses_by_id: null,
        options_by_id: null,
        total_match_query: 0,
        total_match_query_associated: 0,
        filters: [],
        excluded_courses: [],
        nb_inscrits_courses_pending: null,
        nb_inscrits_courses_validated: null,
        nb_inscrits_options_pending: null,
        nb_inscrits_options_validated: null,
    }),
    actions: {
        async search(reload_nb_inscrits = false) {
            const with_nb_inscrits = !this.nb_inscrits_courses_pending || reload_nb_inscrits ? "1" : "0";
            this.loading = true;
            // Ajouter le filtre exclude_course aux filtres
            const filtersWithExclude = [

                ...this.filters,
                {
                    name: 'exclude_course',
                    value: this.exclude_course_filter
                }
            ];
            let request = await AdminService.getPreInscriptionsMaxiRace(filtersWithExclude, with_nb_inscrits, this.id_module);
            if (request) {
                this.selection = request.list;
                this.total_match_query = request.total_match_query;
                this.total_match_query_associated = request.total_match_query_associated;
                if (with_nb_inscrits == "1") {
                    this.nb_inscrits_courses_pending = request.nb_inscrits_courses_pending;
                    this.nb_inscrits_courses_validated = request.nb_inscrits_courses_validated;
                    this.nb_inscrits_options_pending = request.nb_inscrits_options_pending;
                    this.nb_inscrits_options_validated = request.nb_inscrits_options_validated;
                }
            }
            this.loading = false;

        },
        async markFlaggedAsValidated() {
            let request = await AdminService.markFlaggedAsValidated(this.unique_id_commande_flagged);
            if (request) {
                this.search(true);
            }
        },

        initFilters() {
            let coursesNames = ['Toutes les courses', ...Object.keys(this.courses_by_id).map(id => this.courses_by_id[id].nom)];


            const filterCourses = {
                label: "Courses",
                name: "courses",
                value: 'Toutes les courses',
                type: 'select',
                options: coursesNames
            }
            const filterOptions = [];
            for (const option of Object.values(this.options_by_id)) {
                filterOptions.push({
                    label: option.nom,
                    name: 'option_' + option.id,
                    type: 'boolean',
                    options: ['Oui', 'Non'],
                    value: ''

                })
            }


            this.filters = [filterCourses, ...available_fields.map(field => {
                return {
                    label: field.label,
                    name: field.name,
                    value: field.value || '',
                    type: field.type,
                    options: field.options
                }
            }), ...filterOptions];
        },

        async loadCourses(id_module) {
            this.id_module = parseInt(id_module);
            let res = await PublicService.getCourses(id_module);
            this.courses_by_id = res.reduce((acc, course) => {
                acc[course.id] = course;
                return acc;
            }, {});
        },
        async loadOptions(id_module) {
            let res = await PublicService.getOptions(id_module);
            this.options_by_id = res.reduce((acc, option) => {
                acc[option.id] = option;
                return acc;
            }, {});
        },
        selectAll() {
            //apply flagged to true
            this.selection = this.selection.map(inscription => {
                inscription.flagged = true;
                return inscription;
            });

        },
        selectNone() {
            //apply flagged to false
            this.selection = this.selection.map(inscription => {
                inscription.flagged = false;
                return inscription;
            });
        },
        toggleFlag(inscriptionId) {
            // Force la réactivité en réassignant le tableau
            this.selection = this.selection.map(inscription => {
                if (inscription.id === inscriptionId) {
                    inscription.flagged = !inscription.flagged;
                }
                return inscription;
            });
        },
        setFlaggedForIds(ids, flagged) {
            if (!Array.isArray(this.selection) || !ids?.length) {
                return;
            }
            const idSet = new Set(ids);
            this.selection = this.selection.map(inscription => {
                if (idSet.has(inscription.id)) {
                    inscription.flagged = flagged;
                }
                return inscription;
            });
        },
        getTeamSizeByIdCourse(id) {
            if (id == 1345) {
                return 2;
            }
            else if (id == 1419) {
                return 3;
            }
            else if (id == 1420) {
                return 4;
            }

            else {
                return 1;
            }
        },
        toggleExcludedCourse(courseId) {
            const index = this.excluded_courses.indexOf(courseId);
            if (index > -1) {
                this.excluded_courses.splice(index, 1);
            } else {
                this.excluded_courses.push(courseId);
            }
        },
    },
    getters: {
        exclude_course_filter() {
            return this.excluded_courses.join(',');
        },
        unique_id_commande_flagged() {
            if (!this.selection) {
                return [];
            }
            return this.selection.filter(inscription => inscription.flagged).map(inscription => inscription.id_commande).filter((value, index, self) => self.indexOf(value) === index);
        },
        unique_inscriptions_flagged() {
            if (!this.selection) {
                return [];
            }
            let unique_inscription_ids = [];
            for (const inscription of this.selection) {
                if (inscription.flagged) {
                    if (unique_inscription_ids.some(item => item.id_inscription === inscription.id)) {
                        continue;
                    }
                    const item = { id_inscription: inscription.id, id_course: inscription.id_course, options: inscription.options };
                    unique_inscription_ids.push(item);

                    if (inscription.associated && Array.isArray(inscription.associated)) {
                        for (const associated_inscription of inscription.associated) {
                            const item = { id_inscription: associated_inscription.id, id_course: associated_inscription.id_course, options: associated_inscription.options };
                            unique_inscription_ids.push(item);
                        }
                    }
                }
            }
            return unique_inscription_ids;
        },
        nb_inscrits_courses_flagged() {
            let nb_inscrits_courses_selected = {};
            for (let i = 0; i < this.unique_inscriptions_flagged.length; i++) {
                const inscription = this.unique_inscriptions_flagged[i];
                if (nb_inscrits_courses_selected[inscription.id_course]) {
                    nb_inscrits_courses_selected[inscription.id_course] += 1;
                }
                else {
                    nb_inscrits_courses_selected[inscription.id_course] = 1;
                }
            }
            return nb_inscrits_courses_selected;

        },
        nb_inscrits_options_flagged() {
            let nb_inscrits_options_selected = {};
            for (const inscription of this.unique_inscriptions_flagged) {
                for (const option of inscription.options) {
                    if (nb_inscrits_options_selected[option.id]) {
                        nb_inscrits_options_selected[option.id] += parseInt(option.quantite);
                    }
                    else {
                        nb_inscrits_options_selected[option.id] = parseInt(option.quantite);
                    }
                }
            }
            return nb_inscrits_options_selected;
        },
        should_reduce_selection() {
            return this.total_match_query > 300;
        },
        redered_selection() {
            return this.selection?.slice(0, 300);
        },
        available_fields() {
            return available_fields;
        },
        getCourseNameByID() {
            return (id) => {
                return this.courses_by_id?.[id].nom;
            };
        },
        gauge_xaxis() {
            let gauge_xaxis = [];
            if (this.courses_by_id) {
                for (const course of Object.values(this.courses_by_id)) {
                    gauge_xaxis.push(course.nom);
                }
            }
            if (this.options_by_id) {
                for (const option of Object.values(this.options_by_id)) {
                    gauge_xaxis.push(option.nom);
                }
            }
            return gauge_xaxis;
        },

        series_validated() {
            let series_validated = [];
            if (!this.courses_by_id || !this.options_by_id || !this.nb_inscrits_courses_validated || !this.nb_inscrits_options_validated) {
                return [];
            }


            for (const course of Object.values(this.courses_by_id)) {
                const nbInscrits = parseInt(this.nb_inscrits_courses_validated[course.id] ?? 0);
                series_validated.push(nbInscrits);
            }

            for (const option of Object.values(this.options_by_id)) {
                series_validated.push(parseInt(this.nb_inscrits_options_validated[option.id] ?? 0));
            }

            return series_validated;
        },
        series_pending() {
            let series_pending = [];
            if (!this.courses_by_id || !this.options_by_id || !this.nb_inscrits_courses_pending || !this.nb_inscrits_options_pending) {
                return [];
            }


            for (const course of Object.values(this.courses_by_id)) {
                const nbInscrits = parseInt(this.nb_inscrits_courses_pending[course.id] ?? 0);
                series_pending.push(nbInscrits);
            }

            for (const option of Object.values(this.options_by_id)) {
                series_pending.push(parseInt(this.nb_inscrits_options_pending[option.id] ?? 0));
            }
            return series_pending;
        },
        series_selected() {

            let series_selected = [];
            if (!this.courses_by_id || !this.options_by_id || !this.nb_inscrits_courses_flagged || !this.nb_inscrits_options_flagged) {
                return [];
            }




            for (const course of Object.values(this.courses_by_id)) {

                const nbInscrits = parseInt(this.nb_inscrits_courses_flagged[course.id] ?? 0);
                series_selected.push(nbInscrits);

            }

            for (const option of Object.values(this.options_by_id)) {
                series_selected.push(parseInt(this.nb_inscrits_options_flagged[option.id] ?? 0));
            }

            return series_selected;
        },

        validation_summary() {
            if (!this.courses_by_id || !this.options_by_id) {
                return { courses: [], options: [] };
            }

            const mainStore = useMainStore();
            const courses_list = mainStore.module.courses.list || [];
            const options_list = mainStore.module.options.list || [];

            const getCourseMaximum = (id) => {
                const found = courses_list.find(item => item.id == id);
                return parseInt(found?.max_inscrits ?? 0) || 0;
            };
            const getOptionMaximum = (id) => {
                const found = options_list.find(item => item.id == id);
                return parseInt(found?.quantite ?? 0) || 0;
            };

            let courses_summary = [];

            for (const course of Object.values(this.courses_by_id)) {

                const validated = parseInt(this.nb_inscrits_courses_validated?.[course.id] ?? 0);
                const pending = parseInt(this.nb_inscrits_courses_pending?.[course.id] ?? 0);
                const selected = parseInt(this.nb_inscrits_courses_flagged?.[course.id] ?? 0);
                const total = validated + pending + selected;
                courses_summary.push({
                    nom: course.nom,
                    total: total,
                    maximum: getCourseMaximum(course.id),
                });

            }

            // Calculer le récapitulatif pour les options
            let options_summary = [];
            for (const option of Object.values(this.options_by_id)) {
                const validated = parseInt(this.nb_inscrits_options_validated?.[option.id] ?? 0);
                const pending = parseInt(this.nb_inscrits_options_pending?.[option.id] ?? 0);
                const selected = parseInt(this.nb_inscrits_options_flagged?.[option.id] ?? 0);
                const total = validated + pending + selected;

                options_summary.push({
                    nom: option.nom,
                    total: total,
                    maximum: getOptionMaximum(option.id)
                });
            }

            return {
                courses: courses_summary,
                options: options_summary
            };
        },







    }
});


const available_fields = [
    { label: 'Nom', name: 'nom', type: 'text' },
    { label: 'Prénom', name: 'prenom', type: 'text' },
    { label: "Sexe", name: 'sexe', type: 'select', options: ['Tous', 'M', 'F'], value: 'Tous' },
    { label: "Code postal", name: 'code_postal', type: 'text' },
    { label: "Nationalité", name: 'nationalite', type: 'select', options: ["Tous", "Francais", "Etrangers"], value: 'Tous' },
    { label: "Indice Betrail minimum", name: 'indice_betrail_minimum', type: 'number' },
    { label: "Indice Betrail maximum", name: 'indice_betrail_maximum', type: 'number' },
    { label: "A bénéficié d'un code de réduction", name: 'a_beneficie_code_reduction', type: 'boolean', options: ['Oui', 'Non'] },
    { label: "Moyen de locomotion", name: 'moyen_locomotion', type: 'select', options: ["Tous", "Voiture solo", "Voiture covoiturage", "train", "vélo", "avion", "autre"], value: 'Tous' },

    { label: "Inscription groupe partenaire", name: 'inscription_groupe_partenaire', type: 'boolean', options: ['Oui', 'Non'] },
    { label: "Inscription groupe amis", name: 'inscription_groupe_amis', type: 'boolean', options: ['Oui', 'Non'] },
    { label: "Participé à une des courses de la MaXi France", name: 'a_participe_maxi', type: 'boolean', options: ['Oui', 'Non'] },

    { label: "Vient avec famille", name: 'vient_avec_famille', type: 'boolean', options: ['Oui', 'Non'] },
    { label: "Vient entre copains", name: 'vient_entre_copain', type: 'boolean', options: ['Oui', 'Non'] },
    { label: "A une assistance", name: 'assistance_ravitaillement', type: 'boolean', options: ['Oui', 'Non'] }
];

